import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Lock, User } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminLoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      fetch(`${API}/api/auth/me`, { headers: { 'Authorization': `Bearer ${token}` } })
        .then(r => { if (r.ok) navigate('/admin/dashboard'); });
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/auth/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      if (!res.ok) { const d = await res.json(); throw new Error(d.detail || 'Napaka pri prijavi'); }
      const data = await res.json();
      localStorage.setItem('admin_token', data.token);
      navigate('/admin/dashboard');
    } catch (err) { setError(err.message); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <h1 className="font-serif text-3xl text-stone-800 font-bold">Val Dotika</h1>
          <p className="text-stone-500 text-sm mt-1">Admin prijava</p>
        </div>
        <form onSubmit={handleLogin} className="bg-white rounded-2xl p-6 shadow-lg border border-stone-100">
          {error && <div className="bg-red-50 text-red-600 text-sm px-3 py-2 rounded-lg mb-4" data-testid="login-error">{error}</div>}
          <div className="mb-4">
            <label className="block text-stone-700 text-sm font-medium mb-1">Uporabniško ime</label>
            <div className="relative">
              <User size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
              <input type="text" value={username} onChange={e => setUsername(e.target.value)} className="w-full pl-9 pr-4 py-2.5 rounded-lg border border-stone-200 text-sm focus:outline-none focus:ring-2 focus:ring-violet-300" placeholder="admin" required data-testid="login-username" />
            </div>
          </div>
          <div className="mb-6">
            <label className="block text-stone-700 text-sm font-medium mb-1">Geslo</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-9 pr-4 py-2.5 rounded-lg border border-stone-200 text-sm focus:outline-none focus:ring-2 focus:ring-violet-300" placeholder="*****" required data-testid="login-password" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-violet-500 hover:bg-violet-600 text-white rounded-lg py-2.5" data-testid="login-submit">
            {loading ? 'Prijavljanje...' : 'Prijava'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;
